/**
 * Simple Dropdown Toggle for Product Sorter
 * Only handles UI toggle, lets ProductFilter handle the actual filtering
 */
export class ProductSorter {
  constructor(container) {
    this.container = container;
    this.button = container.querySelector("[data-dropdown-toggle]");
    this.popover = container.querySelector("#sort-by-popover");
    this.closeButtons = container.querySelectorAll("[data-dropdown-close]");

    this.isOpen = false;

    this.init();
  }

  init() {
    if (!this.button || !this.popover) {
      console.warn("ProductSorter: Required elements not found");
      return;
    }

    this.setupEventListeners();
    this.setInitialState();
  }

  setupEventListeners() {
    // Toggle dropdown on button click
    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    });

    // Close on close buttons
    this.closeButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    });

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
      }
    });

    // Close when clicking outside
    document.addEventListener("click", (e) => {
      if (this.isOpen && !this.container.contains(e.target)) {
        this.close();
      }
    });

    // Close when filter changes (emitted by ProductFilter)
    window.addEventListener("productFilterChanged", (event) => {
      if (this.isOpen) {
        this.close();
      }
      // Update button text when sorter changes
      this.updateButtonTextFromSelectedOption();
    });

    // Close when clicking on sorter options
    this.container.addEventListener("click", (e) => {
      if (e.target.closest('[role="option"]')) {
        this.close();
      }
    });
  }

  setInitialState() {
    // Find the currently selected option and update button text
    this.updateButtonTextFromSelectedOption();
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.popover.style.display = "block";
    this.button.setAttribute("aria-expanded", "true");

    // Simple fade animation
    setTimeout(() => {
      this.popover.style.opacity = "1";
      this.popover.classList.add("show");
    }, 10);
  }

  close() {
    this.isOpen = false;
    this.popover.style.opacity = "0";
    this.popover.classList.remove("show");
    this.button.setAttribute("aria-expanded", "false");

    // Hide after animation
    setTimeout(() => {
      this.popover.style.display = "none";
    }, 300);
  }

  updateButtonText(text) {
    const buttonTextElement = this.button.querySelector(".button-text");
    if (buttonTextElement) {
      // Update the text to show "Sắp xếp theo: [Selected Option]"
      buttonTextElement.innerHTML = `Sắp xếp theo: <span class="text-gray-900 font-semibold">${text}</span>`;
    }
  }

  updateButtonTextFromSelectedOption() {
    // Find the currently selected option and update button text
    const selectedOption = this.container.querySelector(
      '[aria-selected="true"]'
    );
    if (selectedOption) {
      const text = selectedOption.textContent.trim();
      this.updateButtonText(text);
    } else {
      const allOptions = this.container.querySelectorAll('[role="option"]');
      // Fallback: Check if there's an active class option
      const activeOption = this.container.querySelector(
        '.product-filter-option-active[role="option"]'
      );
      if (activeOption) {
        const text = activeOption.textContent.trim();
        this.updateButtonText(text);
      }
    }
  }
}

// Export for use in main.js
export default ProductSorter;
